module.exports = __webpack_public_path__ + "static/media/upload-video-icon.d1122b57.png";